<template>
    <div>
        <div id="header-container" class="pl-5">
            <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
            <div class="pt-4 text-white">
                <h3 class="text-white">{{ $t('Exchange') }}</h3>
                <span class="fz-16 fw-400">{{ $t('Request currency exchange here') }}</span>
            </div>
        </div>
        
        <b-container fluid class="mt-0 pb-5">
            <b-row class="pt-3">
                <b-col cols="12">
                    <div id="body-container" class="px-3 w-100 mb-4">
                        <h6 class="my-2" >{{ $t('Exchange Form') }}</h6>
                        <div class="d-md-flex align-items-end mb-3">
                            <div class="form-group align-items-center mb-0 pr-3 w-100">
                                <label class="form-label px-2">{{ $t('From Currency') }}</label>
                                <div class="d-flex flex-column w-100">
                                    <select class="form-control" @change="onChangeUserCurrency" v-model="selected_user_currency" ref="userCurrency">
                                        <option value="">-- {{ $t('Select Currency') }} --</option>
                                        <optionUserCurrency
                                        v-if="user_currency.length>0"
                                        v-for="item in user_currency"
                                        :currency = "item"
                                        :mapping_currency = "mapping_currency"
                                        :userNo = "userNo"
                                        :key="item"
                                        :ref="'user_currency_'+item"
                                        >
                                        </optionUserCurrency>
                                    </select>
                                    <div v-if="error.selected_user_currency" class="invalid-feedback d-block">
                                        {{$t(error.selected_user_currency)}}
                                    </div>
                                </div>
                            </div>
                            <img :src="`${publicPath}/img/gep/exchange.svg`" width="42" class="mb-1">
                            <div class="form-group align-items-center mb-0 px-2 w-100">
                                <label class="form-label px-2">{{ $t('To Currency') }}</label>
                                <div class="d-flex flex-column w-100">
                                    <select class="form-control" v-model="selected_list_currency" @change="onChangeListCurrency">
                                        <option value="">-- {{ $t('Select Currency') }} --</option>
                                        <option v-for="item in list_currency" :key="item" :value="item">{{ item }} {{ mapping_currency[item]?' - '+mapping_currency[item]:'' }}</option>
                                    </select>
                                    <div v-if="error.selected_list_currency" class="invalid-feedback d-block">
                                        {{$t(error.selected_list_currency)}}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group align-items-center mb-0 pl-3 w-100">
                                <label class="form-label px-2">{{ $t('Amount') }}</label>
                                <div class="w-100">
                                    <MaskAmount @set-price="changePrice($event)" :bus="exchange" :disabled="selected_user_currency && selected_list_currency && exchangeRate_origin && exchangeRate_target?false:true" ref="exchangeAmount"></MaskAmount>
                                    <div v-if="error.amount" class="invalid-feedback d-block">
                                        {{$t(error.amount)}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-md-flex align-items-center" >
                            <div>
                                <div class="text-grey7 fz-18 fw-600 mb-1" v-if="selected_user_currency && amount>0">{{ selected_user_currency }} {{ amount }} {{ mapping_currency[selected_user_currency] }} =</div>
                                <div v-if="selected_list_currency && amount>0">
                                    <span class="text-primary fz-36 fw-600 mr-2" >{{ selected_list_currency }} {{ calculation }}</span>
                                    <span class="text-grey8 fz-36 fw-600" >{{ mapping_currency[selected_list_currency] }}</span>
                                </div>
                            </div>
                            <div class="ml-auto btn btn-primary btn-convert" @click="doSubmit">{{ $t('Add Exchange') }}</div>
                        </div>
                    </div>
                    <div class="table-record">
                        <div class="block-item px-3">
                            <h6 class="mb-3 mt-2">{{ $t('Exchange List') }}</h6>
                            <ExchangeList :userNo="userNo" v-if="userNo"></ExchangeList>
                        </div>
                    </div>
                </b-col>

            </b-row>
        </b-container>

      <LoaderComponent v-if="isLoading"></LoaderComponent>
    </div>
  </template>
  <script>
  
    import Vue from 'vue';
    import LoaderComponent from "@/components/LoaderComponent";
    import CreateAccount from "@/services/CreateAccount";
    import MaskAmount from "@/components/Mask/MaskAmount";
    import ExchangeList from '@/components/ExchangeList';
    import optionUserCurrency from '@/components/optionUserCurrency';
    import moment from 'moment';

    export default {
        name: 'exchange',
        data() {
            return {
                publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
                exchange:new Vue(),
                selected:{},
                userNo:'',
                calculation:'',
                isLoading : false,
                is_master : false,
                direction : 1,
                exchangeRate_origin:null,
                exchangeRate_target:null,
                user_currency : [],
                list_currency : [],
                originalCcy : '',
                mapping_currency : {},
                selected_user_currency:'',
                selected_list_currency:'',
                amount:0,
                error:{
                    amount:'',
                    selected_list_currency:'',
                    selected_user_currency:''
                }
            }
        },
        components: {
            LoaderComponent,
            MaskAmount,
            ExchangeList,
            optionUserCurrency
        },
        methods:{
            doSubmit(){
                let isValid = true;
                let self = this;
                
                if(!this.selected_user_currency){
                    isValid = false;
                    this.error.selected_user_currency = "please select currency";
                }
                if(!this.selected_list_currency){
                    isValid = false;
                    this.error.selected_list_currency = "please select currency";
                }
                if(this.amount<=0){
                    isValid = false;
                    this.error.amount = "amount should more then 0";
                }

                if(isValid){
                    this.isLoading = true;
                    CreateAccount.doConvert({
                        "userNo":this.userNo,
                        "buyCcy":this.selected_list_currency,
                        "sellCcy":this.selected_user_currency,
                        "closingDate":moment().format('YYYY-MM-DD'),
                        "closingType":"TOD",
                        "direction":this.direction,
                        "buyAmount":this.calculation,
                        "sellAmount":this.amount
                    }).then((response)=>{
                        if (response.status == 200) {
                            self.isLoading = false;
                            this.$swal({
                            icon: 'success',
                            title: this.getMessage('Success'),
                            showConfirmButton: true,
                            }).then((result) => {
                                window.location.reload(); 
                            });
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        self.checkError(err);
                    });
                }
            },
            getResult(amount){
                if(amount>0){
                    return parseFloat(amount).toFixed(2);
                }
                else{
                    return 0;
                }
            },
            getExchangeRate(){
                let self = this;
                if(this.selected_user_currency && this.selected_list_currency){
                    self.error.amount = "";
                    
                    CreateAccount.getExchangeRate({
                        "userNo":this.userNo,
                        "originalCcy":this.selected_user_currency,
                        "targetCcy":this.selected_list_currency,
                        "closingDate":moment().format('YYYY-MM-DD')
                    }).then((response)=>{
                        if(response.data.data.data && response.data.data.data['exchangeRate']){
                            self.exchangeRate_origin = response.data.data.data['exchangeRate'];
                        }
                        else{
                            self.exchangeRate_origin = null;
                            self.error.amount = response.data.data['errorMsg'];
                        }
                    });

                    CreateAccount.getExchangeRate({
                        "userNo":this.userNo,
                        "originalCcy":this.selected_list_currency,
                        "targetCcy":this.selected_user_currency,
                        "closingDate":moment().format('YYYY-MM-DD')
                    }).then((response)=>{
                        if(response.data.data.data && response.data.data.data['exchangeRate']){
                            self.exchangeRate_target = response.data.data.data['exchangeRate'];
                        }
                        else{
                            self.exchangeRate_target = null;
                            self.error.amount = response.data.data['errorMsg'];
                        }
                    });
                }
            },
            onChangeUserCurrency(){
                this.amount = 0;
                this.$refs['exchangeAmount'].price = 0;
                this.error.selected_user_currency='';
                this.getExchangeRate();
                // this.getCurrency();
            },
            onChangeListCurrency(){
                this.amount = 0;
                this.$refs['exchangeAmount'].price = 0;
                this.error.selected_list_currency='';
                this.getExchangeRate();
            },
            getCurrency(){
                let self = this;
                CreateAccount.listCurrency().then((response)=>{
                    this.list_currency = response.data[self.selected_user_currency];
                });
            },
            getSubAccount(){
                let self = this;
                CreateAccount.listSubAccount({
                    start:0,
                    length:-1,
                    search:{value:self.userNo}
                }).then((response)=>{
                    if (response.status == 200) {
                        if(response.data.data.length>0){
                            self.sub_account = response.data.data[0];
                            // self.user_currency = this.sub_account['currency'].split(",");
                            self.user_currency = ["HKD","USD","AUD","SGD","JPY","EUR","GBP","CAD","CNH"];
                            self.list_currency = ["HKD","USD","AUD","SGD","JPY","EUR","GBP","CAD","CNH"];
                            self.getExchangeRate();
                        }
                    }
                });
            },
            changePrice(event){
                this.error.amount = '';
                this.amount = event;
                
                if(this.exchangeRate_origin && this.exchangeRate_target){
                    if(this.exchangeRate_origin>this.exchangeRate_target && this.selected_user_currency){
                        this.direction = 1;
                        this.originalCcy = this.selected_list_currency;
                    }
                    else{
                        this.direction = 2;
                        this.originalCcy = this.selected_user_currency;
                    }

                    console.log("==================");
                    console.log(this.originalCcy);
                    console.log(this.exchangeRate_origin);
                    console.log(this.exchangeRate_target);

                    if(this.selected_user_currency=="USD" && this.exchangeRate_origin == this.exchangeRate_target){
                        // this.direction = 1;
                        this.calculation = (this.amount*this.exchangeRate_target).toFixed(3);
                    }
                    else if(this.originalCcy == this.selected_user_currency){
                        this.calculation = (this.amount/this.exchangeRate_target).toFixed(8);
                    }
                    else{
                        this.calculation = (this.amount*this.exchangeRate_target).toFixed(3);
                    }
                }
                
            },
            getMessage: function (key) {
                return this.$t(key)
            },
            init(){
                let self = this;
                CreateAccount.list().then((response)=>{
                    if (response.status == 200) {
                        let account = response.data.data;
                        if(account){
                            account.forEach(element => {
                                if(element.status == 2){
                                    self.selected = element;
                                    self.userNo = element.userNo;
                                    this.getSubAccount();
                                }
                            });
                        }
                    }
                });
            },
            checkError(err){
                this.isLoading = false;
                const response = err.response;  
                console.log("===================");
                let self = this;
                if(response.status == 400){
                    console.log(response.data);
                    if(typeof response.data.message === 'string'){
                        this.$swal({
                            icon: 'info',
                            html:response.data.message,
                            showConfirmButton: true,
                            confirmButtonText: self.getMessage('OK')
                        });
                    }
                    else{
                        if(response.data.message['errorMsg']){
                            this.$swal({
                                icon: 'info',
                                html:response.data.message['errorMsg'],
                                showConfirmButton: true,
                                confirmButtonText: self.getMessage('OK')
                            });
                        }
                        else{
                            let ret = [];
                            Object.keys(response.data.message).forEach((key) => {
                                ret.push(response.data.message[key][0]);
                            });

                            this.$swal({
                                icon: 'info',
                                html:ret.join("<br>"),
                                showConfirmButton: true,
                                confirmButtonText: self.getMessage('OK')
                            });
                        }
                    }
                }      
                else if(response.status == 401 && response.data.name == "Unauthorized"){
                        localStorage.removeItem("token");
                        localStorage.removeItem("member");
                        localStorage.removeItem("isFirstTime");
                        this.$router.push({ 
                            path: '/login', 
                        });
                }
                else{
                    if(localStorage.getItem("token")){
                        var msg = (response.data)?response.data.message:err.message;
                        this.$notify({
                            type: 'warn',
                            text: msg
                        })
                    }
                }
            }
        },
        mounted(){
            let self = this;
            this.$nextTick(() => {
                CreateAccount.listCurrency().then((response)=>{
                    self.mapping_currency = response.data;
                    self.init();
                });
            });
        }
    };
  </script>
<style scoped>
.block-item{
    border: 1px solid #E5E7EB;
    background: unset;
}
.form-label{
    font-size: 1rem;
}
.btn-convert{
    min-width: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>